module.exports = "//static.hsappstatic.net/marketplace-unified-public-ui/static-1.4308/img/screenshot-twitter.png"